import { FC, useMemo } from 'react'
import { ComposeId } from 'interfaces/feed'
import { createComposeExpandedPartSelector } from 'selectors/feedComposeSelectors'
import { useStoreSelector } from 'helpers/reactReduxHelpers'

type ComposeExpandedProps = {
  composeId: ComposeId
  inverse?: boolean
}

export const ComposeExpanded: FC<ComposeExpandedProps> = (props) => {
  const composeExpandedPartSelector = useMemo(createComposeExpandedPartSelector, [])
  const isExpanded = useStoreSelector((state) => composeExpandedPartSelector(state, props))

  let showContent = isExpanded
  if (props.inverse) {
    showContent = !showContent
  }

  if (showContent) {
    return (
      <>
        { props.children }
      </>
    )
  }

  return null
}
